import script from "./KanbanUnassignedPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanUnassignedPanel.vue?vue&type=script&setup=true&lang=js"

import "./KanbanUnassignedPanel.vue?vue&type=style&index=0&id=6014fbf2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6014fbf2"]])

export default __exports__